import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { uniq } from 'lodash-es';
import { Observable } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { HeadingActions } from './heading.actions';
import { HeadingService } from '../../features/market-comparison/services/heading.service';
import { reportEffectError } from '../../features/shared/utils/report-effect-error';
import { RootState } from '../root-state.model';

@Injectable()
export class HeadingEffects {
  private service = inject(HeadingService);
  private actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);

  loadListEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(HeadingActions.LoadSuggestions),
      withLatestFrom(this.store),
      switchMap(([action, store]) =>
        this.service.getHeadingSuggestionsSimilarity(action.partialTerm).pipe(
          map((list) =>
            HeadingActions.LoadSuggestionsSuccess({
              partialTerm: action.partialTerm,
              list: uniq(list.map((d) => d.text)),
              listStatistics: list.reduce((acc, heading) => {
                acc[heading.text] = `${heading.documentCount} documents`;
                return acc;
              }, {}),
            })
          ),
          reportEffectError(HeadingActions.LoadSuggestionsFail)
        )
      )
    )
  );
}
